var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3622 9.23728C18.3685 9.37816 18.3716 9.52 18.3716 9.66184C18.3716 13.999 15.0697 19 9.03196 19C7.17765 19 5.4525 18.4563 4 17.5249C4.25675 17.5556 4.51794 17.5711 4.78306 17.5711C6.32106 17.5711 7.73615 17.0466 8.85983 16.1662C7.42365 16.1401 6.211 15.1908 5.79315 13.887C5.99403 13.9258 6.19953 13.9459 6.41075 13.9459C6.71031 13.9459 7.0004 13.9059 7.27543 13.8308C5.77409 13.5292 4.64228 12.203 4.64228 10.6128C4.64228 10.5988 4.64228 10.5852 4.64275 10.5718C5.08525 10.8173 5.59172 10.965 6.12937 10.9818C5.24872 10.3934 4.66912 9.38906 4.66912 8.25007C4.66912 7.64893 4.83134 7.08534 5.11381 6.60024C6.73237 8.58587 9.15196 9.89276 11.8798 10.0293C11.8238 9.78909 11.7949 9.53865 11.7949 9.28165C11.7949 7.46919 13.2646 6 15.0775 6C16.0215 6 16.8747 6.39816 17.4736 7.03626C18.2211 6.88883 18.9236 6.61573 19.5581 6.2396C19.3129 7.00617 18.7926 7.64921 18.1145 8.05515C18.7786 7.97629 19.4111 7.79971 20 7.53874C19.5599 8.19696 19.0034 8.77483 18.3622 9.23728Z",
    fill: "#E4E4E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e96ef03d21a938c9ae27b9d887971968.svg";
export { ForwardRef as ReactComponent };